import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const LogoutMobileButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    navigate('/'); // Redirect to home
    window.location.reload(); // Reload page
  };

  return (
    <>


      <div
        onClick={handleLogout}
        className="block font-bold font-inter  hover:bg-gray-200 mx-auto items-center w-1/2"
      >
        <i className="fas fa-sign-out-alt mr-2 text-lg" />
        <span>Logout</span>
      </div>


    </>
  );
};

export default LogoutMobileButton;
